export const AUTH_STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
} as const;

export const API_ENDPOINTS = {
  SSO_INITIATE: '/api/auth/sso/initiate/',
  SSO_GOOGLE: '/api/auth/sso/google/',
  TOKEN_REFRESH: '/api/auth/token/refresh/',
  CURRENT_USER: '/api/users/current-user/',
  LOGOUT: '/api/auth/logout/',
} as const;

export const HTTP_HEADERS = {
  CONTENT_TYPE: 'Content-Type',
  AUTHORIZATION: 'Authorization',
} as const;

export const CONTENT_TYPES = {
  JSON: 'application/json',
} as const;

